import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ClipLoader from "react-spinners/ClipLoader";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";

const EditAgreementModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [agent, setAgent] = useState("");
  const [brokerage, setBrokerage] = useState("");
  const [status, setStatus] = useState("");
  const [state, setState] = useState("");
  const [sending, setSending] = useState(false);

  const statusList = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "Draft", value: "draft" },
  ];

  const stateList = [
    { label: "California", value: "CA" },
    { label: "Texas", value: "TX" },
    { label: "Florida", value: "FL" },
    { label: "Nevada", value: "NV" },
  ];

  const handleStatusChange = (value) => {
    setStatus(value);
  };

  const handleStateChange = (value) => {
    setState(value);
  };

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      setRowId(editData.id);
      setAgent(editData.agent || "");
      setBrokerage(editData.brokerage || "");
      setStatus(editData.status || "");
      setState(editData.state || "");
    }
  }, [editData, mounted]);

  const handleSubmit = async () => {
    if (!agent || !brokerage || !status || !state) {
      Toast("All fields required.", "error");
      return;
    }

    console.log({
      rowId,
      agent,
      brokerage,
      status,
      state,
    });

    return;

    // your API integration here
  };

  if (!mounted) return null;

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">
              {editData ? "Edit" : "Add Agreement"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter Agent name"
                  value={agent}
                  onChange={(e) => setAgent(e.target.value)}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter Brokerage"
                  value={brokerage}
                  onChange={(e) => setBrokerage(e.target.value)}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <SelectFieldComponent
                  firstOption={status || "Select Status"}
                  optionsList={statusList}
                  onSelectChange={handleStatusChange}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={12}>
                <SelectFieldComponent
                  firstOption={state || "Select State"}
                  optionsList={stateList}
                  onSelectChange={handleStateChange}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    sending ||
                    agent.length <= 2 ||
                    brokerage.length <= 2 ||
                    !status ||
                    !state
                      ? "bg-dark-subtle"
                      : "shadow"
                  } `}
                  text={
                    sending ? (
                      <ClipLoader color="#0f0f0f" size="22px" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={
                    sending ||
                    agent.length <= 2 ||
                    brokerage.length <= 2 ||
                    !status ||
                    !state
                  }
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditAgreementModal;
